module.exports = "<span>{{data&&data!=''?data:'-'}}</span>\r\n"